import { render, staticRenderFns } from "./FirstTeletag.vue?vue&type=template&id=514e40aa"
import script from "./FirstTeletag.vue?vue&type=script&lang=js"
export * from "./FirstTeletag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports